import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthClient } from '../auth/AuthClient';
import { useAuth } from '../hooks/useAuth';
const ProtectedRoute = ({ children, requiredActions = [] }) => {
    const { isAuthenticated, isLoading, isDenied, user, login, state, error } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        if (!isLoading && !isAuthenticated && state.status !== 'error' && state.status !== 'denied') {
            sessionStorage.setItem('auth_return_to', location.pathname);
            login();
        }
    }, [isAuthenticated, isLoading, location.pathname, login, state.status]);
    useEffect(() => {
        if (isAuthenticated && !isLoading) {
            const returnTo = AuthClient.consumePendingReturnTo();
            if (returnTo)
                void navigate(returnTo, { replace: true });
        }
    }, [isAuthenticated, isLoading, navigate]);
    if (isLoading) {
        return _jsx("div", { style: { padding: 20, textAlign: 'center' }, children: "Loading..." });
    }
    if (state.status === 'error') {
        return (_jsxs("div", { style: { padding: 20, textAlign: 'center' }, children: [_jsx("h2", { children: "Authentication Error" }), _jsx("p", { children: error }), _jsx("button", { onClick: () => login(), children: "Retry Login" })] }));
    }
    if (isDenied) {
        return (_jsxs("div", { style: { padding: 20, textAlign: 'center' }, children: [_jsx("h2", { children: "Access denied" }), _jsx("p", { children: "This platform is available to Autodesk accounts only." })] }));
    }
    if (!isAuthenticated)
        return null;
    if (requiredActions.length > 0 && user) {
        const hasPermission = requiredActions.every((a) => user.actions.includes(a));
        if (!hasPermission) {
            return (_jsxs("div", { style: { padding: 20, textAlign: 'center' }, children: [_jsx("h2", { children: "Unauthorized" }), _jsx("p", { children: "You do not have permission to access this page." })] }));
        }
    }
    return _jsx(_Fragment, { children: children });
};
export default ProtectedRoute;
